import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

//components
import { LayoutFloatPipCameraPlayerComponent } from './pip-camera-player/pip-camera-player.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
      LayoutFloatPipCameraPlayerComponent
    ],
    exports: [
      LayoutFloatPipCameraPlayerComponent
    ],

})
export class CoreLayoutFloatModule { }
